import React from 'react';
import { DividerPropsModel} from './tools/Divider.model';
import clsx from 'clsx';

import useStyles from './Divider.style';

export const Divider: React.FC<DividerPropsModel> = ({
  size = "normal",
  equalMargin = false,
  fullWidth = false,
  noMarginTop = false,
  noMarginBottom = false,
  className}) => {
    const c = useStyles({ size, equalMargin, fullWidth, noMarginTop, noMarginBottom });

    return <hr className={clsx(c.root, className)} />;
};
